<template>

    <router-view></router-view>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import di from 'di'
    import { Events } from '@wittignl/js-core/auth/Manager'

    @Component({

        name: 'app'
    })
    export default class extends Vue
    {
        mounted() {

            this.logger = this.$logger.child('App');

            di.get('auth').on(Events.LOGOUT, this.onLogout, this);
        }

        onLogout(){

            this.logger.warn('Logged out, resetting Apollo store');

            di.get('apollo').resetStore();
            document.location.href = di.get('config').loginUrl;
        }
    }

</script>
